import { render } from "./TakEawayfries.vue?vue&type=template&id=7f07d9a2"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/TakEawayfries.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f07d9a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f07d9a2', __exports__)) {
    api.reload('7f07d9a2', __exports__)
  }
  
  module.hot.accept("./TakEawayfries.vue?vue&type=template&id=7f07d9a2", () => {
    api.rerender('7f07d9a2', render)
  })

}


export default __exports__